module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_5012.436d40bc.png";